<div role="contentinfo" class="footer text-white text-center bg-white">
  <img alt="" class="club-logo" [src]="'logos/logo.svg' | contentAssetImage" draggable="false" />

  <div class="headline-sponsors">
    <img alt="" class="cmc-logo" [src]="'footer/cmc.svg' | contentAssetImage" draggable="false" />
    <img alt="" class="stadium-logo" [src]="'footer/hilldickinson.png' | contentAssetImage" draggable="false" />
  </div>

  <div class="footer-row row-one">
    <img alt="" class="row-one-logo" [src]="'footer/castore.png' | contentAssetImage" draggable="false" />
    <img alt="" class="row-one-logo" [src]="'footer/fanatics.png' | contentAssetImage" draggable="false" />
    <img alt="" class="row-one-logo" [src]="'footer/christopher-ward.png' | contentAssetImage" draggable="false" />
    <ng-container *notInPopulation="[populations.U18]">
      <img alt="" class="row-one-logo" [src]="'footer/budwiser.png' | contentAssetImage" draggable="false" />
    </ng-container>
    <img alt="" class="row-one-logo" [src]="'footer/seat-unique.png' | contentAssetImage" draggable="false" />
    <img alt="" class="row-one-logo" [src]="'footer/aramark.png' | contentAssetImage" draggable="false" />
    <img alt="" class="row-one-logo" [src]="'footer/pepsi.png' | contentAssetImage" draggable="false" />
  </div>

  <!--Desktop Footer-->
  <ng-container *ifScreenSize="screenSize.Desktop">
    <div class="footer-row">
      <img alt="" class="row-two-logo" [src]="'footer/ticketmaster.png' | contentAssetImage" draggable="false" />

      <img alt="" class="row-two-logo" [src]="'footer/sefc.png' | contentAssetImage" draggable="false" />

      <ng-container *notInPopulation="[populations.U18]">
        <img alt="" class="row-two-logo" [src]="'footer/nemiroff.png' | contentAssetImage" draggable="false" />
      </ng-container>
      <img alt="" class="row-two-logo" [src]="'footer/redbull.png' | contentAssetImage" draggable="false" />
      <img alt="" class="row-two-logo" [src]="'footer/davanti.png' | contentAssetImage" draggable="false" />
      <img alt="" class="row-two-logo" [src]="'footer/strauss.png' | contentAssetImage" draggable="false" />
    </div>

    <div class="footer-row">
      <img alt="" class="row-three-logo" [src]="'footer/corpay.png' | contentAssetImage" draggable="false" />
      <img alt="" class="row-three-logo" [src]="'footer/sportsbreaks.png' | contentAssetImage" draggable="false" />
      <img alt="" class="row-three-logo" [src]="'footer/hpe.png' | contentAssetImage" draggable="false" />
      <img alt="" class="row-three-logo" [src]="'footer/ocs.png' | contentAssetImage" draggable="false" />
      <img alt="" class="row-three-logo" [src]="'footer/ggm.png' | contentAssetImage" draggable="false" />
      <img alt="" class="row-three-logo" [src]="'footer/heinz.png' | contentAssetImage" draggable="false" />
    </div>
  </ng-container>

  <!--Mobile Footer-->
  <ng-container *ifScreenSize="screenSize.Mobile">
    <div class="footer-mobile-row">
      <img alt="" class="mobile-logo" [src]="'footer/ticketmaster.png' | contentAssetImage" draggable="false" />
      <img alt="" class="row-two-logo" [src]="'footer/sefc.png' | contentAssetImage" draggable="false" />
      <ng-container *notInPopulation="[populations.U18]">
        <img alt="" class="mobile-logo" [src]="'footer/nemiroff.png' | contentAssetImage" draggable="false" />
      </ng-container>

      <img alt="" class="mobile-logo" [src]="'footer/redbull.png' | contentAssetImage" draggable="false" />
      <img alt="" class="row-two-logo" [src]="'footer/davanti.png' | contentAssetImage" draggable="false" />
      <img alt="" class="row-two-logo" [src]="'footer/strauss.png' | contentAssetImage" draggable="false" />
    </div>

    <div class="footer-mobile-row">
      <img alt="" class="mobile-logo" [src]="'footer/corpay.png' | contentAssetImage" draggable="false" />
      <img alt="" class="mobile-logo" [src]="'footer/sportsbreaks.png' | contentAssetImage" draggable="false" />
      <img alt="" class="row-three-logo" [src]="'footer/hpe.png' | contentAssetImage" draggable="false" />
      <img alt="" class="row-three-logo" [src]="'footer/ocs.png' | contentAssetImage" draggable="false" />
      <img alt="" class="row-three-logo" [src]="'footer/ggm.png' | contentAssetImage" draggable="false" />
      <img alt="" class="row-three-logo" [src]="'footer/heinz.png' | contentAssetImage" draggable="false" />
    </div>
  </ng-container>
  <div class="all-rights-reserved text-black">
    <p>{{ 'footer.page.all.rights.reserved' | translate }}</p>
  </div>
</div>
